import { css } from "@emotion/react";
import { IBuilderBlockProps } from "../..";

export const defaultStyleProps: IBuilderBlockProps = {
    margin: ["0", "0", "0", "0"],
    padding: ["0", "0", "0", "0"],
    height: "auto",
    width: "auto",

}

export const defaultCssStyles = ({ margin, padding, width, height, minWidth,
    maxWidth,
    minHeight,
    maxHeight, }: IBuilderBlockProps) => {
    return css`
        width: ${width};
        height: ${height};
        margin: ${margin ? `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px` : null};
        padding: ${padding ? `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px` : null};
        min-width: ${minWidth};
          max-width: ${maxWidth};
          min-height: ${minHeight};
          max-height: ${maxHeight};
`}